import { ProductCategory } from 'src/app/shared/models/productCategory.model';
import { Injectable } from '@angular/core';

@Injectable()
export class CategoryService{
    
    selectedCategory: ProductCategory = new ProductCategory();
    constructor(){}
}